/**
 * The default font set is based on Angular Material's. Leave [fontSet]="" to user Material Icons.
 *
 * In order to use FontAwesome, set the font set to one of the following:
 */
export const ICON_FONT_SET = {
  FA_DEFAULT: "fal",
  FA_SOLID: "fas",
  FA_REGULAR: "far",
  FA_LIGHT: "fal",
  FA_DUOTONE: "fad",
  FA_THIN: "fat",
  FA_BRANDS: "fab"
};

/**
 * Define icons used across the application using FontAwesome
 *
 * Implementation:
 *
 * .ts
 * get icons() {
 *  return ICONS;
 * }
 *
 * .html with FontAwesome
 * <mat-icon [fontSet]="('' | function: userDefinedIconFontSet) | async" [fontIcon]="icons.ACTIVE" ></mat-icon>
 *
 *
 * @NOTE refer to https://fontawesome.com/icons?d=gallery to see all available icons that are loaded with the application.
 *
 * @IMPORTANT In order to use these icons run the following commands:
 * 1. npm config set "@fortawesome:registry" https://npm.fontawesome.com/
 * 2. npm config set "//npm.fontawesome.com/:_authToken" <AUTH TOKEN FROM ACCOUNT>
 * 3. npm install --save @fortawesome/fontawesome-pro
 */
export const ICONS = {
  ACTIVE: "fa-check",
  ADD: "fa-plus",
  ADMIN: "fa-user-plus",
  ALERT: "fa-bell",
  ARROW_BACK: "fa-arrow-left",
  ARROW_FWD: "fa-arrow-right",
  ARROW_POINTER: "fa-hand-pointer",
  ARROW_LAYER_DOWN: "fa-down-from-line",
  ARROW_LAYER_UP: "fa-up-from-line",
  ATTACH_DOCUMENT: "fa-paperclip",
  ANNOTATIONS: "fa-file-pen",
  APPLICATIONS: "fa-list-dropdown",
  APPLICATIONS_TAB: "fa-window",
  ACTIVITY: "fa-clock-rotate-left",
  AT: "fa-at",
  BOLD: "fa-bold",
  CAUTION: "fa-diamond-exclamation",
  COMMON: "fa-sliders",
  BACKGROUND_COLOR: "fa-fill-drip",
  CARDS: "fa-table-rows",
  CARET_RIGHT: "fa-caret-right",
  CAPS: "fa-font-case",
  CALENDAR: "fa-calendar",
  CANCEL: "fa-times",
  CHECK_CIRCLE: "fa-check-circle",
  CHEVRON_DOWN: "fa-chevron-down",
  CHEVRON_RIGHT: "fa-chevron-right",
  CIRCLE: "fa-circle",
  CLOSE: "fa-times",
  CLEAR: "fa-times",
  COMMENTS: "fa-comment-dots",
  CONTACT_INFORMATION: "fa-address-book",
  COPY: "fa-copy",
  CROWN: "fa-crown",
  CLOUD: "fa-cloud",
  COOKIES: "fa-cookie",
  CUSTOMER: "fa-people-group",
  CUSTOMER_SEARCH: "fa-user-magnifying-glass",
  DARK_MODE: "fa-moon-cloud",
  DASHBOARD: "fa-gauge-high",
  DELETE: "fa-trash-alt",
  DELETE_ALL: "fa-trash-list",
  DELETE_SELECTED: "fa-trash-check",
  DELETE_WARNING: "fa-hand",
  DISCARD: "fa-circle-question",
  DOCUMENTS: "fa-file-alt",
  DOCUMENTS_PLUS: "fa-file-circle-plus",
  DOCUMENT_VIEW: "fa-search",
  DOCUMENT_LIST: "fa-book",
  DOCUMENT_UPLOAD: "fa-arrow-up-from-bracket",
  DOCUMENT_SCAN: "fa-scanner-image",
  DOWNLOAD_AS_TEXT: "fa-font",
  DPI: "fa-border-style",
  DOWNLOAD: "fa-download",
  DRAW: "fa-pen-line",
  DROPDOWN: "fa-angle-down",
  EDIT: "fa-edit",
  EMAIL: "fa-envelope",
  ENVIRONMENT: "fa-network-wired",
  EVEN_SPREAD: "fa-columns",
  ERROR: "fa-circle-exclamation",
  EXTENSION: "fa-phone-volume",
  FAVORITE: "fa-heart",
  FOLDER: "fa-folder",
  FOLDER_PLUS: "fa-folder-plus",
  FILE_ROOM: "fa-books-medical",
  FILTER: "fa-filter",
  FLIP_HORIZONTAL: "fa-arrows-left-right",
  FLIP_VERTICAL: "fa-arrows-up-down",
  FILE_INVOICE: "fa-file-invoice",
  FULL_SCREEN: "fa-expand-wide",
  GROUPS: "fa-layer-group",
  HAND_TOOL: "fa-hand-paper",
  HELP: "fa-question-circle",
  HOME: "fa-house-user",
  HIDE: "fa-eye-slash",
  HINTS: "fa-lightbulb-on",
  HISTORY: "fa-rectangle-history",
  HOLD: "fa-pause-circle",
  LANGUAGE: "fa-globe",
  LIST_CHECK: "fa-list-check",
  LINE: "fa-horizontal-rule",
  LINK: "fa-arrow-up-right-from-square",
  LOADER: "fa-spinner",
  LOGIN: "fa-sign-in-alt",
  LOGO: "fa-image",
  MAPS: "fa-map-location-dot",
  NOTES: "fa-notes",
  IMAGE_EMPTY: "fa-image-slash",
  INBASKET: "fa-inbox",
  INBASKET_FULL: "fa-inbox-full",
  INFO: "fa-info-circle",
  INBOX: "fa-inbox-full",
  IFRAME: "fa-browser",
  ITALIC: "fa-italic",
  MENU_ITEMS: "fa-list-alt",
  MESSAGES: "fa-comment-alt-lines",
  MODULES: "fa-window",
  MORE: "fa-ellipsis-v",
  MIC: "fa-microphone",
  NEXT: "fa-chevron-right",
  NEWS: "fa-newspaper",
  NO_SPREAD: "fa-page-break",
  NOT_AVAILABLE: "fa-fire",
  NOT_FOUND: " fa-face-worried",
  ODD_SPREAD: "fa-table",
  ONDEMAND: "fa-square-caret-right",
  PAGE_UP: "fa-arrow-up",
  PAGE_DOWN: "fa-arrow-down",
  PREVIOUS: "fa-chevron-left",
  PRINT: "fa-print",
  PLAY: "fa-play-circle",
  MARK_UNREAD: "fa-envelope-open",
  MARK_READ: "fa-envelope",
  MORE_ROUTES: "fa-ellipsis-h",
  PASTE: "fa-paste",
  POLY: "fa-draw-polygon",
  REFRESH: "fa-redo",
  RELEASE: "fa-bags-shopping",
  REMINDERS: "fa-calendar-check",
  REPLY: "fa-reply",
  REPORTS: "fa-file-user",
  REPORTS_PLUS: "fa-file-chart-pie",
  RESET_PASSWORD: "fa-unlock-alt",
  RESTART: "fa-sync",
  REVERT: "fa-undo",
  ROLES: "fa-user-check",
  ROTATE_CCW: "fa-undo",
  ROTATE_CW: "fa-redo",
  SAVE: "fa-save",
  SEND: "fa-paper-plane-top",
  SEARCH_HISTORY: "fa-folder-magnifying-glass",
  STRIKETHROUGH: "fa-strikethrough",
  SEARCH: "fa-search",
  SELECT: "fa-check",
  SELECT_ALL: "fa-check-double",
  SELECT_ZOOM: "fa-square-dashed",
  SETTINGS: "fa-cog",
  SIDE_BAR: "fa-list",
  SIGNATURE: "fa-signature",
  SIGNOFF: "fa-sign-out-alt",
  SUPPORT_SERVICES: "fa-star",
  SORT: "fa-arrow-up-a-z",
  SQUARE: "fa-square",
  STAMP: "fa-stamp",
  STOP: "fa-stop",
  TASKS: "fa-tasks",
  TEMPLATE: "fa-pen-to-square",
  TEXT: "fa-text",
  TEXT_COLOR: "fa-square-a",
  TEXT_HIGHLIGHT: "fa-highlighter",
  THEMES: "fa-palette",
  TIME: "fa-clock",
  TOGGLE: "fa-bars",
  TEXT_FIELDS: "fa-text",
  UNDERLINE_TEXT: "fa-underline",
  USER: "fa-user",
  USER_ENABLE: "fa-user-unlock",
  USER_DISABLE: "fa-user-lock",
  USER_PROFILES: "fa-users",
  USER_SETTINGS: "fa-user-circle",
  VIEW: "fa-eye",
  WATERMARK: "fa-water",
  ZOOM_IN: "fa-search-plus",
  ZOOM_OUT: "fa-search-minus",
  ZOOM: "fa-search-location"
};
